import { useEffect } from 'react';
import { FaInfo } from 'react-icons/fa';
import Dropdown from 'react-bootstrap/Dropdown';

import { push, useRouteMatch } from '../../app/route';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  selectCurrentTenantId,
} from '../user/userSlice';
import {
  selectRolesAndActions,
  listRolesAction,
  updateRoleAction,
  deleteRoleAction,
  getRoleListUrl,
  getRoleCreateUrl,
  getRoleDetailUrl,
} from './roleSlice';

export function RoleListPage() {
  const dispatch = useAppDispatch();
  const roles = useAppSelector(selectRolesAndActions);
  const tenant_id = useAppSelector(selectCurrentTenantId);
  const match = useRouteMatch<{ tenant_id: string }>();
  useEffect(() => {
    if (match.params.tenant_id !== tenant_id) {
      dispatch(push(getRoleListUrl(tenant_id)));
    }
  }, [tenant_id, match, dispatch]);
  useEffect(() => {
    dispatch(listRolesAction({ tenant_id }));
  }, [tenant_id, dispatch]);

  const goDetail = (mode: 'view'|'edit', role_id: string) => {
    dispatch(push(getRoleDetailUrl(tenant_id, role_id, mode)));
  };
  const goCreate = () => {
    dispatch(push(getRoleCreateUrl(tenant_id)));
  };
  const handleDeleteRole = async(role_name: string) => {
    let result = await dispatch(deleteRoleAction({
      tenant_id,
      name: role_name,
    }));
    if (deleteRoleAction.fulfilled.match(result)) {
      dispatch(listRolesAction({ tenant_id }));
    }
  };
  const handleEnableRole = async(role_name: string) => {
    let result = await dispatch(updateRoleAction({
      tenant_id,
      name: role_name,
      body: { state: 'enabled' },
    }));
    if (updateRoleAction.fulfilled.match(result)) {
      dispatch(listRolesAction({ tenant_id }));
    }
  };
  const handleDisableRole = async(role_name: string) => {
    let result = await dispatch(updateRoleAction({
      tenant_id,
      name: role_name,
      body: { state: 'disabled' },
    }));
    if (updateRoleAction.fulfilled.match(result)) {
      dispatch(listRolesAction({ tenant_id }));
    }
  };
  return (
    <div className="container">
      <div className="d-flex justify-content-between py-4">
        <h1>Roles</h1>
        <button className="btn btn-primary my-2" onClick={() => goCreate()}>
          Create
        </button>
      </div>
      <table className="table">
        <thead className="table-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Title</th>
            <th scope="col">Name</th>
            <th scope="col">Type</th>
            <th scope="col">RoleId</th>
            <th scope="col">State</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {roles.map((role, index) => {
            return (
              <tr key={role.role_id}>
                <th scope="row">{ index+1 }</th>
                <td>{role.title}</td>
                <td>{role.name}</td>
                <td>{role.type}</td>
                <td>{role.role_id}</td>
                <td>{role.state}</td>
                <td>
                  <Dropdown>
                    <Dropdown.Toggle variant="dark" id={'action-'+index}>
                      <FaInfo/>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      { role.$action.can_enable && 
                        <Dropdown.Item onClick={() => handleEnableRole(role.name)}>Enable</Dropdown.Item>
                      }
                      { role.$action.can_disable &&
                        <Dropdown.Item onClick={() => handleDisableRole(role.name)}>Disable</Dropdown.Item>
                      }
                      { role.$action.can_edit &&
                        <Dropdown.Item onClick={() => goDetail('edit', role.role_id)}>Edit</Dropdown.Item>
                      }
                      { role.$action.can_view &&
                        <Dropdown.Item onClick={() => goDetail('view', role.role_id)}>View</Dropdown.Item>
                      }
                      { role.$action.can_delete &&
                        <Dropdown.Item onClick={() => handleDeleteRole(role.name)}>Delete</Dropdown.Item>
                      }
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
